import Cookies from "js-cookie";

export const AC_TENANT_ID_COOKIE = "AC_TENANT_ID";
export const X_TENANT_ID_HEADER = "x-tenant-id";

/** Read Assessment Center / AI Plan tenant id from cookie. */
export function getAcTenantId(): string {
  return String(Cookies.get(AC_TENANT_ID_COOKIE) ?? "").trim();
}

/**
 * Watch AC_TENANT_ID cookie changes (poll + focus/visibility).
 * Cookies have no native change event, so this is best-effort for host-driven updates.
 */
export function subscribeAcTenantId(
  listener: (next: string, prev: string) => void,
  options?: { intervalMs?: number },
): () => void {
  let last = getAcTenantId();
  const intervalMs = options?.intervalMs ?? 1000;

  const check = () => {
    const next = getAcTenantId();
    if (next === last) return;
    const prev = last;
    last = next;
    listener(next, prev);
  };

  const intervalId = window.setInterval(check, intervalMs);
  window.addEventListener("focus", check);
  document.addEventListener("visibilitychange", check);

  return () => {
    window.clearInterval(intervalId);
    window.removeEventListener("focus", check);
    document.removeEventListener("visibilitychange", check);
  };
}

/** True when the request targets auto-tagging / AI Plan APIs. */
export function isAutoTaggingApiUrl(url: string | undefined): boolean {
  if (!url) return false;
  return (
    url.includes("/auto-tagging") ||
    url.includes("/assessment") ||
    url.includes("/knowledge_manager/concepts")
  );
}
